import React, { useLayoutEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { surveysAPI } from '../../api/services/surveys'
import { PatientSurveyData } from '../../api/services/surveys/types.ts'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Card from '../../components/common/Card/Card.tsx'

const PatientSurveyDetails = () => {
  const { patientProfileId, patientSurveyId } = useParams<{
    patientProfileId: string
    patientSurveyId: string
  }>()
  const location = useLocation()
  const { patientFullName } = location.state
  const [patientSurvey, setPatientSurvey] = useState<PatientSurveyData | null>(
    null
  )

  const fetchData = async () => {
    if (patientSurveyId) {
      const response =
        await surveysAPI.getPatientSurveyDetails<PatientSurveyData>(
          Number(patientSurveyId)
        )
      setPatientSurvey(response.data)
    }
  }

  useLayoutEffect(() => {
    fetchData()
  }, [])

  return (
    <React.Fragment>
      <Breadcrumbs
        pageName="Szczegóły ankiety pacjenta"
        breadcrumbs={[
          { label: 'Pacjenci', path: '/patient-profile' },
          {
            label: patientFullName,
            path: `/patient-profile/${patientProfileId}`
          },
          { label: 'Ankieta pacjenta' }
        ]}
      />

      {patientSurvey && (
        <div className={'flex flex-col md:flex-row gap-4'}>
          <Card className="md:w-2/3">
            <Card.Title>{patientSurvey.survey_name}</Card.Title>

            <Card.Body className="pr-2">
              <p className={'text-xl font-bold mb-4'}>
                {'Odpowiedzi pacjenta:'}
              </p>

              {patientSurvey.patient_survey_answers.map((answer, index) => (
                <div
                  className={'flex flex-col md:flex-col pb-3' as const}
                  key={answer.id as number}
                >
                  <p>
                    {index + 1}. {answer?.question as string}
                  </p>
                  <ul className="list-disc list-inside">
                    <li className={'font-bold pl-4'}>
                      {(answer?.answers as string[]).join(',')}
                    </li>
                  </ul>
                </div>
              ))}
            </Card.Body>
          </Card>

          <Card className="md:w-1/3">
            <Card.Title>{'Podsumowanie'}</Card.Title>
            <Card.Body className="flex flex-col">
              {patientSurvey.required_tests.length > 0 && (
                <p className={'text-xl font-bold mb-4'}>
                  {'Lista badań na podstawie odpowiedzi:'}
                </p>
              )}
              {patientSurvey.required_tests.map((test) => (
                <p key={test}>{test}</p>
              ))}

              {patientSurvey.required_tests.length === 0 && (
                <div className="flex-1 flex flex-col">
                  <p className="text-xl font-bold mb-4">
                    {'Liczba otrzymanych punktów:'}
                  </p>

                  <div className="flex-1 flex items-center justify-center">
                    <p className="flex items-center justify-center w-[70px] h-[70px] rounded-full bg-orange-200">
                      <span className={'text-3xl font-bold'}>{patientSurvey.patient_points_score}</span>
                    </p>
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      )}
    </React.Fragment>
  )
}

export default PatientSurveyDetails
